import React from 'react';
import { formatFieldLabel } from '../helpers';

export default function FieldLabel({ name, children }) {
  const label = children || formatFieldLabel(name);

  return (
    <div className="mb-1 text-sm font-medium text-gray-500 shrink-0">
      {label}:
    </div>
  );
}
